export { default } from './FactCardReferral';
